import React from "react";
import { useStateValue } from "../StateProvider";
import "./Checkout.css";
import CheckoutProduct from "./CheckoutProduct";
import Subtotal from "./Subtotal";

const Checkout = () => {
  const [{ basket, user }, dispatch] = useStateValue();

  return (
    <div className="checkout">
      <div className="checkout__left">
        <img
          className="checkout_ad"
          alt="ad"
          src="https://thumbs.dreamstime.com/b/experience-buying-goods-online-fast-delivery-buy-now-shop-right-up-e-commerce-technology-vector-illustration-concept-152543403.jpg"
        />
        <div>
          <h3>Hello {user ? user.email : "Guest"}</h3>
          <h2 className="checkout__title">Your shopping Basket</h2>
          {/* CheckoutProduct */}
          {basket?.map((item) => (
            <CheckoutProduct
              id={item.id}
              title={item.title}
              price={item.price}
              rating={item.rating}
              image={item.image}
            />
          ))}
          {/* Item */}
          {/* Item */}
        </div>
      </div>
      <div className="checkout__right">
        <Subtotal />
      </div>
    </div>
  );
};

export default Checkout;
